import { render, staticRenderFns } from "./EditSponsorProfile.vue?vue&type=template&id=5f24ec04"
import script from "./EditSponsorProfile.vue?vue&type=script&lang=js"
export * from "./EditSponsorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports